import { AsyncStateStatus } from '../root.types'

/**
 * Redux Actions Company
 * @typedef CompanyTypes
 * @namespace CompanyTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 *
 * <ul>
 *   <li>@company/companyRequest</li>
 *   <li>@company/describeRequest</li>
 * </ul>
 *
 * @memberof CompanyTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum CompanyTypes {
    COMPANY_REQUEST = '@company/companyRequest',
    DESCRIBE_REQUEST = '@company/describeRequest',
}

/**
 * @memberof CompanyTypes
 * @interface IActionCompanyRequest
 * @category React
 * @subcategory Redux / Types
 * @property {string} cnpj Company data CNPJ.
 * @property {string} razaoSocial Company data razaoSocial.
 * @property {string} inscricaoEstadual Company data inscricaoEstadual.
 * @property {string} socioCpf Company data socioCpf.
 * @property {string} socioNome Company data socioNome.
 * @property {string} socioCnpj Company data socioCnpj.
 * @property {string} email Company data email.
 * @property {string} telefone Company data telefone.
 */
export interface IActionCompanyRequest {
    readonly cnpj: string,
    readonly razaoSocial?: string,
    readonly inscricaoEstadual?: string,
    readonly socioCpf?: string,
    readonly socioNome?: string,
    readonly socioCnpj?: string,
    readonly email?: string,
    readonly telefone?: string,
    readonly start_date?: string,
    readonly end_date?: string,
}

/**
 * @memberof CompanyTypes
 * @interface IDescribeState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} cnpj
 * @property {string} razaoSocial
 * @property {Array} companyDescribe
 * @property {Array} companyConts
 * @property {Array} companyOwner
 * @property {Array} companyAutos
 * @property {Array} companyWorklist
 */
export interface IDescribeState {
    readonly status: AsyncStateStatus,
    readonly cnpj: string,
    readonly razaoSocial: string,
    readonly companyDescribe: ITabState,
    readonly companyConts: ITabState,
    readonly companyAddress: ITabState,
    readonly companyOwner: ITabState,
    readonly companyAutos: ITabState,
    readonly companyWorklist: ITabState,
    readonly companyCounters: ITabState
}

/**
 * @memberof CompanyTypes
 * @interface ICompanyState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} cnpj
 * @property {string} razaoSocial
 * @property {Array} data
 */
export interface ICompanyState {
    readonly status: AsyncStateStatus,
    readonly razaoSocial: string,
    readonly data: any[]
}

export interface ITabState {
    readonly status: AsyncStateStatus,
    readonly data: Array<any>
}

/**
 * @memberof CompanyTypes
 * @interface CompanyState
 * @category React
 * @subcategory Redux / Types
 * @property {ICompanyState} request
 * @property {IDescribeState} describe
 */
export interface CompanyState {
    request: ICompanyState,
    describe: IDescribeState
}
